export const routes = (prefix = `reports`) => [
    {
        path: `/${prefix}/pharmacy/issue-report`,
        name: `${prefix}.pharmacy-issue-report.index`,
        component: () => import('./issue/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.pharmacy-issue-report.index`,
                PageDescription: "Report: Pharmacy Issue Report",
            },
        },
    },{
        path: `/${prefix}/pharmacy/outpatientsummary-report`,
        name: `${prefix}.pharmacy-outpatientsummary-report.index`,
        component: () => import('./OutpatientSummary/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.pharmacy-outpatientsummary-report.index`,
                PageDescription: "Report: Pharmacy Outpatient Summary Report",
            },
        },
    }, {
        path: `/${prefix}/pharmacy/outpatientsummary-report/print`,
        name: `${prefix}.pharmacy-outpatientsummary-report.print`,
        component: () => import('./OutpatientSummary/Print.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.pharmacy-outpatientsummary-report.index`,
                PageDescription: "Report: Pharmacy Outpatient Summary Report",
            },
            print: true,
        },
    },
];
